import { Helmet } from 'react-helmet';
import Button from '../components/ui/Button';

export default function NotFoundPage() {
  return (
    <main className="section-container section-spacing text-center">
      <Helmet>
        <title>Page Not Found | Carter Asset Management</title>
      </Helmet>
      <p className="text-sm font-semibold uppercase tracking-wide text-cam-blue/70">404</p>
      <h1 className="mt-3 text-4xl md:text-5xl font-semibold tracking-tight text-cam-blue">Charted waters not found.</h1>
      <p className="mt-4 text-base text-slate-600">
        The page you are looking for may have moved. Head back to the homepage or reach out for support.
      </p>
      <div className="mt-6 flex justify-center gap-4">
        <Button type="button" onClick={() => (window.location.href = '/')}>Return Home</Button>
        <Button type="button" variant="secondary" onClick={() => (window.location.href = '/contact')}>
          Contact Us
        </Button>
      </div>
    </main>
  );
}
